import './style.scss'

import { mapGetters } from 'vuex'

export default {
  name: 'Logo',
  computed: {
    ...mapGetters(['lang'])
  },
  render (h) {
    const { lang } = this
    return (
      <router-link class='Logo' to={lang === 'en' ? '/en' : '/'} exact>
        <img class='Logo__img' src='/imgs/logo.svg' alt='Logo' />
      </router-link>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Logo/index.js